var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowForwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-forward-ios-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8496 3.18176C17.0996 3.45606 17.2246 3.78084 17.2246 4.15609C17.2246 4.53061 17.0996 4.85502 16.8496 5.12932L9.52461 13.1665L16.8746 21.2311C17.1079 21.4871 17.2246 21.8071 17.2246 22.1911C17.2246 22.5752 17.0996 22.9043 16.8496 23.1786C16.5996 23.4529 16.3036 23.5901 15.9616 23.5901C15.6203 23.5901 15.3246 23.4529 15.0746 23.1786L6.67461 13.9345C6.57461 13.8248 6.50361 13.7059 6.46161 13.5779C6.42028 13.4499 6.39961 13.3128 6.39961 13.1665C6.39961 13.0202 6.42028 12.883 6.46161 12.755C6.50361 12.627 6.57461 12.5081 6.67461 12.3984L15.0996 3.15432C15.3329 2.89831 15.6203 2.7703 15.9616 2.7703C16.3036 2.7703 16.5996 2.90745 16.8496 3.18176Z",
    fill: "#808D9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIcon);
export default __webpack_public_path__ + "static/media/arrow-forward-icon.2f7b0d40af8336d84d0564fe617d5b81.svg";
export { ForwardRef as ReactComponent };